import apiClient from '../index';

const whatsAppApi = {
  // Get WhatsApp webhook (configuration)
  getWebhook: () => apiClient.get('/whatsapp/webhook'),
  
  // Create/Update WhatsApp webhook
  setWebhook: (data) => apiClient.post('/whatsapp/webhook', data),
  
  // Get all WhatsApp chats
  getAllChats: (params = {}) => apiClient.get('/whatsapp/chats', { params }),
  
  // Get WhatsApp chat with specific number
  getChatByNumber: (number) => apiClient.get(`/whatsapp/chats/${number}`),
  
  // Get WhatsApp chats for specific event
  getEventChats: (eventId, params = {}) => apiClient.get(`/whatsapp/event-chats/${eventId}`, { params }),
  
  // Send WhatsApp message
  sendMessage: (data) => apiClient.post('/whatsapp/send', data),
  
  // Send bulk WhatsApp messages
  sendBulkMessages: (data) => apiClient.post('/whatsapp/send-bulk', data),
  
  // Get WhatsApp chat status
  getChatStatus: (chatId) => apiClient.get(`/whatsapp/chats/${chatId}/status`),
  
  // Mark message as read
  markAsRead: (messageId) => apiClient.put(`/whatsapp/messages/${messageId}/read`),
  
  // Delete chat
  deleteChat: (number) => apiClient.delete(`/whatsapp/chats/${number}`),
  
  // Get WhatsApp message history
  getMessageHistory: (number, params = {}) => apiClient.get(`/whatsapp/chats/${number}/messages`, { params }),
  
  // Get WhatsApp global history
  getWhatsappHistory: (eventId = null, params = {}) => {
    const queryParams = eventId ? { ...params, event_id: eventId } : params;
    return apiClient.get('/messaging/whatsapp-history', { params: queryParams });
  }
};

export default whatsAppApi;
